class LuluKarimokuHome {
  constructor(root) {
    this.root = root;
    this.drawer = root.querySelector('[data-lulu-karimoku-drawer]');
    this.closeButtons = root.querySelectorAll('[data-lulu-karimoku-drawer-close]');
    this.boundKeydown = this.onKeydown.bind(this);
    this.init();
  }

  init() {
    this.initDrawer();
    this.initMotion();
  }

  initDrawer() {
    if (!this.drawer) return;

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => this.closeDrawer());
    });

    this.drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => this.closeDrawer());
    });

    document.addEventListener('keydown', this.boundKeydown);
  }

  initMotion() {
    const reveals = [...this.root.querySelectorAll('[data-lulu-reveal]')];
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach((section) => section.classList.add('is-visible'));
      return;
    }

    this.root.classList.add('lulu-karimoku--motion-ready');
    this.motionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.motionObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -8% 0px' },
    );
    reveals.forEach((section) => this.motionObserver.observe(section));
  }

  closeDrawer() {
    this.drawer?.removeAttribute('open');
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.closeDrawer();
  }

  destroy() {
    this.motionObserver?.disconnect();
    document.removeEventListener('keydown', this.boundKeydown);
  }
}

const findLuluKarimokuHomes = (scope) => {
  const roots = [...scope.querySelectorAll('[data-lulu-karimoku-home]')];
  if (scope.matches?.('[data-lulu-karimoku-home]')) roots.unshift(scope);
  return roots;
};

const initializeLuluKarimokuHome = (scope = document) => {
  findLuluKarimokuHomes(scope).forEach((root) => {
    root.luluKarimokuHome?.destroy();
    root.dataset.luluKarimokuReady = 'true';
    root.luluKarimokuHome = new LuluKarimokuHome(root);
  });
};

initializeLuluKarimokuHome();

document.addEventListener('shopify:section:load', (event) => {
  initializeLuluKarimokuHome(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  findLuluKarimokuHomes(event.target).forEach((root) => root.luluKarimokuHome?.destroy());
});
